/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileTypeArchiveIcon16Light } from './FileTypeArchiveIcon16Light';
import { FileTypeArchiveIcon16Regular } from './FileTypeArchiveIcon16Regular';
import { FileTypeArchiveIcon16Solid } from './FileTypeArchiveIcon16Solid';
import { FileTypeArchiveIcon20Light } from './FileTypeArchiveIcon20Light';
import { FileTypeArchiveIcon20Regular } from './FileTypeArchiveIcon20Regular';
import { FileTypeArchiveIcon20Solid } from './FileTypeArchiveIcon20Solid';
import { FileTypeArchiveIcon24Regular } from './FileTypeArchiveIcon24Regular';
import { FileTypeArchiveIcon24Solid } from './FileTypeArchiveIcon24Solid';
import { FileTypeArchiveIcon32Regular } from './FileTypeArchiveIcon32Regular';
import { FileTypeArchiveIcon64Regular } from './FileTypeArchiveIcon64Regular';
var sizes = {
    16: {
        light: FileTypeArchiveIcon16Light,
        regular: FileTypeArchiveIcon16Regular,
        solid: FileTypeArchiveIcon16Solid,
    },
    20: {
        light: FileTypeArchiveIcon20Light,
        regular: FileTypeArchiveIcon20Regular,
        solid: FileTypeArchiveIcon20Solid,
    },
    24: {
        regular: FileTypeArchiveIcon24Regular,
        solid: FileTypeArchiveIcon24Solid,
    },
    32: {
        regular: FileTypeArchiveIcon32Regular,
    },
    64: {
        regular: FileTypeArchiveIcon64Regular,
    },
};
export var FileTypeArchiveIcon = forwardRef('FileTypeArchiveIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
